var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-skeleton-loader',_vm._g(_vm._b({staticClass:"custom-skeleton-preloader"},'v-skeleton-loader',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }